export default __webpack_public_path__ + "static/media/paper-box_gray.c48ad6cc.svg";